import { Flex } from 'antd'
import { ProgressHeader } from 'pages/auth/registration/components/ProgressHeader'
import { useRef } from 'react'
import { useIntl } from 'react-intl'
import { GridContainer } from 'shared/ui'
import CodeInput, { CodeInputRef } from 'shared/ui/CodeInput/CodeInput'
import { useConfirmEmailCodeMutation, useSendEmailCodeQuery } from '../api'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setActivity } from 'shared/config/store/reducers/appSlice'
import { useMessage } from 'shared/libs/hooks'
import { ApiError } from 'shared/model/types'
import { ROUTES } from 'shared/const/routes'
import { useLazyGetUserInfoQuery, useLazyGetUserQuery, useSaveGtagMutation } from 'entities/user';
import { GTAG_ID } from 'shared/const/app'

export const ConfirmEmail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = params.get('email');
  const phone = params.get('phone');
  const codeRef = useRef<CodeInputRef>(null);
  const { formatMessage: t } = useIntl();
  const { isLoading: isLoadingSendPhone, refetch: refetchCodeSend } = useSendEmailCodeQuery();
  const [confirmEmailCode, { isLoading: isLoadingConfirmPhone }] = useConfirmEmailCodeMutation();
  const [fetchUserInfo] = useLazyGetUserInfoQuery();
  const [fetchUser] = useLazyGetUserQuery();
  const [saveGtag] = useSaveGtagMutation();

  const dispatch = useDispatch();

  const handleCodeConfirm = (code: string) => {
    dispatch(setActivity(true));
    confirmEmailCode({ code })
      .unwrap()
      .then(async (response) => {
        // Обновляем информацию о пользователе после успешного подтверждения email
        // чтобы статус verified был актуальным
        await Promise.all([
          fetchUserInfo(),
          fetchUser(),
        ]);
        
        gtag('get', GTAG_ID, 'client_id', (clientID) => {
          saveGtag({ clientId: clientID as string, eventName: 'web_email_verification_completed', gtag: GTAG_ID });
          gtag('event', 'web_email_verification_completed', {
            email_verification: true
          });
        });
        codeRef.current?.success();
        // Переход на подтверждение телефона только при успешном подтверждении email
        navigate({ pathname: ROUTES.CONFIRM_PHONE.path, search: `phone=${phone}&email=${email}` })
      })
      .catch((error: ApiError) => {
        console.log(error);
        codeRef.current?.clear();
        codeRef.current?.error(t({ id: 'schemas.invalid' }));
      })
      .finally(() => {
        dispatch(setActivity(false));
      })
  }

  return (
    <GridContainer>
      <Flex vertical gap={40}>
        <ProgressHeader sectionIndex={4} last={6} title={t({ id: 'screens.auth.email.title' })} onBack={() => navigate(ROUTES.LOGIN.path)} description={t({ id: 'screens.verifyEmail.subTitle' }, { email: email })} />
        <Flex justify='center'>
          <CodeInput timeout={30} ref={codeRef} isPhone onResend={refetchCodeSend} onEnter={handleCodeConfirm} />
        </Flex>
      </Flex>
    </GridContainer>
  )
}